export default {
  actions: {
    createPhase({ dispatch }, phase) {
      this.$authorize('edit', 'Opportunity')

      return Vue.$http.post(`admin/opportunities/${phase.opportunity.id}/phases`, { phase }).then(
        () => dispatch('fetch', phase.opportunity.id)
      )
    },
    removePhase({ dispatch }, phase) {
      this.$authorize('edit', 'Opportunity')

      return Vue.$http.delete(`admin/opportunities/${phase.opportunity.id}/phases/${phase.id}`).then(
        () => dispatch('fetch', phase.opportunity.id)
      )
    },
    updatePhase({ dispatch }, phase) {
      this.$authorize('edit', 'Opportunity')

      return Vue.$http.patch(`admin/opportunities/${phase.opportunity.id}/phases/${phase.id}`, { phase }).then(
        () => dispatch('fetch', phase.opportunity.id)
      )
    }
  }
}
